export default function CommunityReach() {
  const reachStats = [
    {
      icon: 'ri-user-star-line',
      number: '300+',
      label: 'Youth Players',
      color: 'bg-purple-100 text-purple-700'
    },
    {
      icon: 'ri-parent-line',
      number: '600+',
      label: 'Parents & Family',
      color: 'bg-yellow-100 text-yellow-700'
    },
    {
      icon: 'ri-group-line',
      number: '1,000+',
      label: 'Game Day Crowds',
      color: 'bg-purple-100 text-purple-700'
    },
    {
      icon: 'ri-share-line',
      number: '5,000+',
      label: 'Social Media Reach',
      color: 'bg-yellow-100 text-yellow-700'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-6">
            Reach <span className="text-yellow-600">Hundreds</span> Of Local Families
          </h2>
          <p className="text-2xl text-gray-700 max-w-3xl mx-auto font-medium">
            Your sponsorship gives your business exposure to an engaged, local audience
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16">
          {reachStats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className={`w-24 h-24 flex items-center justify-center mx-auto mb-6 rounded-2xl ${stat.color}`}>
                <i className={`${stat.icon} text-5xl`}></i>
              </div>
              <div className="text-5xl font-black text-gray-900 mb-3">{stat.number}</div>
              <div className="text-xl font-bold text-gray-700">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-purple-700 to-purple-900 rounded-3xl p-12 md:p-16 text-center shadow-2xl">
          <div className="max-w-4xl mx-auto">
            <div className="w-20 h-20 flex items-center justify-center mx-auto mb-8 bg-yellow-400 rounded-full">
              <i className="ri-heart-3-fill text-4xl text-purple-900"></i>
            </div>
            
            <h3 className="text-4xl md:text-5xl font-black text-white mb-8 leading-tight">
              Parents Remember The Businesses<br />That Support Their Kids
            </h3>
            
            <p className="text-xl text-purple-100 leading-relaxed">
              When you sponsor CYFA, you're not just advertising—you're building genuine goodwill and loyalty within the community. Local families notice and appreciate businesses that invest in their children's future.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}